import React, { useEffect, useState,useRef } from 'react';
import Navbar from '../Navbar';
import { useLocation } from 'react-router-dom';
function ShowAddress() {
//   const [data, setData] = useState(null);
  const [walletAddress, setWalletAddress] = useState('');
  const [walletadd,setwalletadd]=useState('');
  const location = useLocation();
  var bools = location.state?.bools || false;
  const boolsref=useRef(bools);
  
  useEffect(() => {
   setwalletadd(localStorage.getItem('address'));
   console.log(boolsref.current);
   if (walletadd){
    boolsref.current =true;
  }
  }, [walletadd]);

  useEffect(() => {
    // console.log('Invoked',walletadd);
    console.log(localStorage.getItem('walletaddress'));
    setWalletAddress(localStorage.getItem('address'));
    console.log('Wallet Address:', walletAddress);
   if (walletAddress){
    boolsref.current=false;
   }
  }, [walletAddress]);

  return (
    <>
      <Navbar showMenu={false} walletConnected={boolsref.current} />

      <div className="container" style={{ marginTop: '200px', position: 'relative' }}>
        <h1>Show Address</h1>
        <p>Connected Wallet Address: {walletadd}</p>
        {/* <p>Data Address: {data?.address}</p> */}
      </div>
    </>
  );
}

export default ShowAddress;


// Nami wallet connection code

// import React from 'react';

// export default class ShowAddress extends React.Component {
//     constructor(props) {
//         super(props);
//         this.state = {
//             address: '',
//         };
//     }

//     componentDidMount() {
//         this.connectNamiWallet();
//     }

//     connectNamiWallet = async () => {
//         if (window.cardano && window.cardano.nami && window.cardano.nami.enable) {
//             try {
//                 const namiAPI = await window.cardano.nami.enable();
//                 const addresses = await namiAPI.getUsedAddresses();
//                 const address = addresses[0]; // Assuming the first address is the desired one
//                 this.setState({ address });
//             } catch (error) {
//                 console.error('Failed to enable Nami wallet:', error);
//             }
//         } else {
//             console.error('Nami wallet not found.');
//         }
//     };

//     render() {
//         const { address } = this.state;

//         return (
//             <div>
//                 <script>
//                     alert({address})
//                 </script>
//                 <h1>Nami Wallet</h1>
//                 <p>Connected Wallet Address: {address}</p>
//             </div>
//         );
//     }
// }